import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import styled from 'styled-components';

import AccordionResult, { Header } from '../accordion-result';
import { MISSING } from '../../lib/exercise.js';
import { CorrectionContent } from '../correction-content';

const ResultsContainer = styled.div`
    max-width: 100%;

    @media print {
        display: block;
    }

    &.over-size ${Header} {
        height: 64px;
    }
`;

export const CorrectionResults = ({
    answers = [],
    exercises,
    expand,
    filter,
    geogebraExercises,
    solution = false,
    correctionsStatus = [],
    videos,
    onPlayVideo,
    correctionPoints = [],
    source,
    exerciseIndexOffset = 0,
}) => {
    const calculatePoints = (exercise) => {
        if (!exercise.difficulty) {
            return 0;
        }

        const exerciseCorrectionPoints = correctionPoints.find((c) => c.exerciseId === exercise.id);

        if (exerciseCorrectionPoints && exerciseCorrectionPoints.totalAnswers !== 0) {
            return (exerciseCorrectionPoints.correctAnswers / exerciseCorrectionPoints.totalAnswers) * exercise.difficulty;
        }

        return 0;
    };

    const containerRef = useRef(null);

    const setOverSizeClass = () => {
        if (!containerRef.current.className.includes('over-size')) {
            containerRef.current.className += ' over-size';
        }
    };

    const hasPartialPoints = correctionPoints.some((c) => !!c.totalAnswers);

    return (
        <ResultsContainer ref={containerRef} flexDirection="column">
            {exercises.map((exercise, index) => {
                const exerciseAnswer = answers.find((answer) => answer.exerciseId === exercise.id);
                const correctionStatus = correctionsStatus.find((correctionStatus) => correctionStatus.exerciseId === exercise.id);

                const points = calculatePoints(exercise);

                return (
                    <AccordionResult
                        title={exercise.publicTitle || `Esercizio n. ${index + 1}`}
                        key={index}
                        status={correctionStatus ? correctionStatus.state : MISSING}
                        filter={filter}
                        number={exercise.executionIndex + 1 || exerciseIndexOffset + index + 1}
                        expand={expand}
                        solution={solution}
                        difficulty={exercise.difficulty}
                        exerciseId={exercise.originalId}
                        points={points}
                        hasPartialPoints={hasPartialPoints}
                        source={source}
                        setOverSizeClass={setOverSizeClass}
                    >
                        <CorrectionContent
                            answer={exerciseAnswer}
                            correctionStatus={correctionStatus}
                            exercise={exercise}
                            geogebraExercises={geogebraExercises}
                            onPlayVideo={onPlayVideo}
                            solution={solution}
                            videos={videos}
                        />
                    </AccordionResult>
                );
            })}
        </ResultsContainer>
    );
};

CorrectionResults.propTypes = {
    answers: PropTypes.array,
    exercises: PropTypes.array,
    expand: PropTypes.bool,
    filter: PropTypes.string,
    geogebraExercises: PropTypes.array,
    correctionsStatus: PropTypes.array,
    solution: PropTypes.bool,
    onPlayVideo: PropTypes.func,
    videos: PropTypes.array,
    correctionPoints: PropTypes.array,
    source: PropTypes.string,
    exerciseIndexOffset: PropTypes.number,
};

export default CorrectionResults;
